import React, { useEffect, useState } from 'react';
import styled from 'styled-components';
import Player from '@vimeo/player';
import VisibilitySensor from 'react-visibility-sensor';
import Countdown from 'react-countdown-now';
import { getFadeTransition } from '../../utils/transitions';
import { isIOS, isTablet } from 'react-device-detect';
import { isFieldValid } from '../../utils/validation';
import { getFieldValue } from '../../utils/helpers';
const Container = styled.div `
  position: relative;
  width: 100%;
  height: 100%;
  display: flex;
  justify-content: center;
  align-items: center;
`;
const IFrame = styled.iframe `
  border: none;
  width: 100%;
  margin: 0;
  padding: 0;
`;
const CountdownTextContainer = styled.div `
  text-align: center;
  position: absolute;
  left: 50%;
  top: 50%;
  transform: translate(-50%, -50%);
  z-index: 99;
  color: ${({ theme }) => theme.primaryWhite};
  animation: 1s ease-out 0s 1 ${getFadeTransition(0, 1)};
`;
const Paragraph = styled.p `
  font-family: ${({ theme }) => theme.fontFamilyBase};
  font-style: normal;
  font-weight: normal;
  font-size: 18px;
  line-height: 28px;
  margin: 0px;
`;
export const Video = ({ media, ariaLabel, onCompleted, hasCountdown, height, }) => {
    if (!isFieldValid(media, 'url')) {
        return null;
    }
    const url = getFieldValue(media, 'url');
    const [isVisible, setIsVisible] = useState(true);
    const [shouldCountdown, setShouldCountdown] = useState(false);
    // handle autoplay in tablet
    const [shouldAutoplay, setShouldAutoplay] = useState(true);
    useEffect(() => {
        const srcScript = document.createElement('script');
        srcScript.src = url;
        const iframeObj = document.getElementById('videoFrame');
        const player = new Player(iframeObj);
        if (typeof window !== 'undefined' && !!navigator) {
            if (isIOS && isTablet && shouldAutoplay) {
                player.play();
                setShouldAutoplay(false);
            }
        }
        if (!isVisible) {
            player.pause();
        }
        player.on('ended', () => {
            if (hasCountdown) {
                setShouldCountdown(true);
            }
        });
        player.on('play', () => {
            if (hasCountdown) {
                setShouldCountdown(false);
            }
        });
        // handle component unmount
        return () => {
            player.off('ended');
            player.off('play');
        };
    }, [isVisible]);
    return (React.createElement(VisibilitySensor, { onChange: setIsVisible, partialVisibility: true, delayedCall: true, 
        // handle visibility during countdown
        active: shouldCountdown ? false : true },
        React.createElement(Container, null,
            React.createElement(IFrame, { id: 'videoFrame', height: height ? height + '%' : '100%', "aria-label": ariaLabel, src: url, "data-ready": "true", frameborder: "0", allow: "autoplay; fullscreen", allowfullscreen: true, webkitallowfullscreen: true, mozAllowFullScreen: true }),
            shouldCountdown && (React.createElement(CountdownTextContainer, null,
                React.createElement(Paragraph, null, "End of Video"),
                React.createElement(Paragraph, null,
                    'Video Closes in ',
                    React.createElement(React.Fragment, null,
                        React.createElement(Countdown, { date: Date.now() + 5000, onComplete: onCompleted, renderer: (props) => React.createElement("span", null, props.seconds) }),
                        "...")))))));
};
